<core-site-plugins-plugin-content *ngIf="component && method" [component]="component" [method]="method" [args]="args"
    [initResult]="initResult" [data]="data" />
